(function () {
  'use strict';

  var ROOT = '[data-dv-proof]';
  var subscriptions = {};

  function id(value) {
    return value === null || value === undefined ? '' : String(value);
  }

  function roots(productId) {
    var selector = productId ? ROOT + '[data-product-id="' + productId + '"]' : ROOT;
    return Array.prototype.slice.call(document.querySelectorAll(selector));
  }

  function activeVariantId(root, variant) {
    if (variant && variant.id) return id(variant.id);
    var productId = root.getAttribute('data-product-id');
    var form = document.querySelector('form[data-product-id="' + productId + '"]:not(#sticky-atc-form)');
    var input = form && form.querySelector('[name="id"]');
    return input && id(input.value);
  }

  function render(root, variant) {
    var variantId = activeVariantId(root, variant);
    if (!variantId) return;
    var entry = root.querySelector('[data-dv-proof-variant="' + variantId + '"]');
    if (!entry) return;
    var text = entry.getAttribute('data-proof') || '';
    root.querySelectorAll('[data-dv-proof-text]').forEach(function (node) {
      node.textContent = text;
    });
    var primary = entry.getAttribute('data-primary') || '';
    root.querySelectorAll('[data-dv-primary-text]').forEach(function (node) {
      node.textContent = primary;
    });
    var ctw = entry.getAttribute('data-ctw') || '';
    root.querySelectorAll('[data-dv-ctw]').forEach(function (node) {
      node.textContent = ctw;
    });
    var productId = root.getAttribute('data-product-id');
    document.querySelectorAll('form[data-product-id="' + productId + '"]').forEach(function (form) {
      var button = form.querySelector('button.add-to-cart');
      var label = button && button.querySelector('.atc-text');
      var current = label && (label.textContent || '').trim();
      if (!label || !/^Add (to bag|to cart|charm)/i.test(current)) return;
      label.textContent = 'Add to Bag';
      button.setAttribute('data-atc-text', 'Add to Bag');
    });
    var product = window._themeProducts && window._themeProducts[root.getAttribute('data-product-id')];
    var selected = product && Array.isArray(product.variants) && product.variants.filter(function (item) {
      return id(item.id) === variantId;
    })[0];
    root.querySelectorAll('[data-dv-sku]').forEach(function (node) {
      node.textContent = selected && selected.sku || '';
    });
  }

  function renderProduct(productId, variant) {
    roots(productId).forEach(function (root) { render(root, variant); });
  }

  function schedule(productId, variant) {
    [0, 60, 180, 400].forEach(function (delay) {
      window.setTimeout(function () { renderProduct(productId, variant); }, delay);
    });
  }

  function bind(root) {
    var productId = root.getAttribute('data-product-id');
    if (!productId || subscriptions[productId]) {
      render(root);
      return;
    }
    var bus = window.MinimogEvents || window._ThemeEvent;
    if (bus && typeof bus.subscribe === 'function') {
      subscriptions[productId] = bus.subscribe(productId + '__VARIANT_CHANGE', function (variant) {
        schedule(productId, variant);
      });
    }
    renderProduct(productId);
  }

  function money(cents) {
    var number = Number(cents);
    if (!Number.isFinite(number)) return '';
    var amount = number / 100;
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: (window.MinimogSettings && window.MinimogSettings.currency_code) || 'USD',
      minimumFractionDigits: Math.round(amount * 100) % 100 === 0 ? 0 : 2,
      maximumFractionDigits: 2
    }).format(amount);
  }

  function labelVariantPrices() {
    document.querySelectorAll('form[data-product-id]:not(#sticky-atc-form)').forEach(function (form) {
      var product = window._themeProducts && window._themeProducts[form.dataset.productId];
      if (!product || !Array.isArray(product.variants)) return;
      var picker = form.querySelector('select[name^="options"], .sf-product-variant-option-dropdown');
      if (!picker) return;
      if (product.variants.length === 1) {
        var block = picker.closest('.main-product__block');
        if (block) block.hidden = true;
        return;
      }
      Array.prototype.forEach.call(picker.options || [], function (option) {
        var variant = product.variants.find(function (item) {
          return item.title === option.value || item.public_title === option.value;
        });
        if (!variant) return;
        var originalValue = option.value;
        var base = variant.public_title || variant.title || originalValue;
        option.textContent = base + ' — ' + money(variant.price);
        option.value = originalValue;
      });
    });
  }

  function cleanUpsellCopy() {
    var replacements = {
      'Add Your Chain': 'Pair it with a signature DIVETIA chain',
      'Choose a necklace or bracelet': 'Pair it with a signature DIVETIA chain',
      'Add a necklace or bracelet — optional': 'Pair it with a signature DIVETIA chain'
    };
    function visit(root) {
      if (!root || !root.querySelectorAll) return;
      root.querySelectorAll('*').forEach(function (node) {
        if (node.shadowRoot) visit(node.shadowRoot);
        Array.prototype.forEach.call(node.childNodes || [], function (child) {
          if (child.nodeType !== 3) return;
          var original = (child.textContent || '').trim();
          if (replacements[original]) child.textContent = replacements[original];
          if (original.indexOf('Claim Offer') === 0) {
            child.textContent = child.textContent.replace('Claim Offer', 'Add');
          }
        });
      });
    }
    visit(document);
  }

  function init() {
    roots().forEach(bind);
    labelVariantPrices();
    cleanUpsellCopy();
  }

  document.addEventListener('change', function (event) {
    var form = event.target && event.target.closest && event.target.closest('form[data-product-id]');
    if (form) {
      schedule(form.getAttribute('data-product-id'));
      window.setTimeout(labelVariantPrices, 220);
      window.setTimeout(cleanUpsellCopy, 500);
    }
  });
  document.addEventListener('click', function (event) {
    var form = event.target && event.target.closest && event.target.closest('form[data-product-id]');
    if (form) schedule(form.getAttribute('data-product-id'));
  });
  var cleanupObserver = new MutationObserver(function () {
    window.clearTimeout(cleanupObserver.timer);
    cleanupObserver.timer = window.setTimeout(cleanUpsellCopy, 80);
  });
  cleanupObserver.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(cleanUpsellCopy, 600);
  window.setTimeout(cleanUpsellCopy, 1600);
  window.addEventListener('pageshow', init);
  window.addEventListener('popstate', init);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
